import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/me`;

export const getMyProfile = async () => apiClient(`${BASE}/profile`);

export const getMyCollaborator = async () => apiClient(`${BASE}/collaborator`);

export const updateMyPassword = async (payload) =>
  apiClient(`${BASE}/password`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const getMyRequests = async () => apiClient(`${BASE}/requests`);

export const getMyRequest = async (requestId) => apiClient(`${BASE}/requests/${requestId}`);

export const createMyRequest = async (payload) =>
  apiClient(`${BASE}/requests`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
